import styled from 'styled-components'

const ResponsiveFonts = styled.div`
  font-size: 1rem;
  @media screen and (max-width:1750px) {
    font-size: .95rem;
  }
  @media screen and (max-width:1600px) {
    font-size: .85rem;
  }
  @media screen and (max-width:1500px) {
    font-size: .80rem;
  }
  @media screen and (max-width:1300px) {
    font-size: .75rem;
  }
  @media screen and (max-width:1200px) {
    font-size: .75rem;
  }
  @media screen and (max-width:1100px) {
    font-size: .7rem;
  }
`

export default ResponsiveFonts
